export default __webpack_public_path__ + "static/media/chevron.2188c2ab.svg";